import React, { Suspense } from 'react';
import BarcodePrintComponent from '../Component/BarcodePrintComponent/BarcodePrintComponent';

function BarcodePrintPage(props) {
    return (
        <>
            <Suspense fallback={<div>Loading...</div>}>
                <BarcodePrintComponent />
            </Suspense>
        </>
    );
}

export default BarcodePrintPage;